import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
export default class WebsocketUpdates {
  constructor() {
    _defineProperty(this, "discussions", {});
    _defineProperty(this, "releaseInterval", app.forum.attribute('flarum-realtime.release-discussion-updates-interval'));
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "onTimerCallback", null);
    _defineProperty(this, "seconds", this.releaseInterval);
  }
  length() {
    return Object.keys(this.discussions).length;
  }
  push(discussion) {
    this.discussions[discussion.id()] = discussion;
  }
  remove(discussion) {
    delete this.discussions[discussion.id()];
  }
  has(discussion) {
    return !!this.discussions[discussion.id()];
  }
  isEmpty() {
    return this.length() === 0;
  }
  reset() {
    this.discussions = {};
  }
  getReleaseInterval() {
    return this.releaseInterval;
  }

  /**
   * Releases new discussion updates to the discussion list.
   */
  release(state) {
    // Push all discussions to the UI list.
    Object.keys(this.discussions).forEach(id => {
      state.addDiscussion(this.discussions[id]);
    });

    // Reset new discussions array.
    this.reset();

    // Reset page count.
    app.setTitleCount(0);
  }

  /**
   * Starts the timer that will release new discussion updates to the discussion list.
   */
  startTimer() {
    if (this.autoRelease()) {
      clearInterval(this.timer);
      this.seconds = this.getReleaseInterval();
      this.timer = window.setInterval(() => {
        if (this.seconds < 0 && this.timer) return clearInterval(this.timer);
        this.seconds--;
        this.onTimerCallback && this.onTimerCallback(this.seconds);
      }, 1000);
    }
  }
  onTimer(callback) {
    this.onTimerCallback = callback;
  }
  autoRelease() {
    return this.releaseInterval > 0;
  }
}
flarum.reg.add('flarum-realtime', 'forum/extend/DiscussionList/WebsocketUpdates', WebsocketUpdates);